var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M18.9986 14.4322C18.9986 14.5307 18.9955 14.7444 18.9896 14.9095C18.9752 15.3135 18.9431 15.8348 18.8947 16.0723C18.8219 16.4292 18.712 16.7661 18.5688 17.0466C18.2349 17.7045 17.6999 18.2388 17.0416 18.5719C16.7597 18.7155 16.4207 18.8255 16.0618 18.898C15.8266 18.9454 15.3093 18.9772 14.9079 18.9911C14.7423 18.997 14.5288 19 14.4307 19L5.56746 18.9986C5.4689 18.9986 5.2552 18.9955 5.0901 18.9896C4.68611 18.9752 4.16483 18.9431 3.9273 18.8947C3.5704 18.8219 3.23344 18.7121 2.95307 18.5688C2.29526 18.2349 1.76106 17.6999 1.42811 17.0416C1.28411 16.7597 1.17446 16.4207 1.10202 16.0618C1.05458 15.8267 1.02282 15.3093 1.00886 14.9079C1.00295 14.7428 1 14.5288 1 14.4308L1.00144 5.56761C1.00144 5.46904 1.00446 5.25534 1.01037 5.09025C1.02477 4.68626 1.05688 4.16498 1.10526 3.92745C1.17806 3.57076 1.288 3.23387 1.43121 2.95343C1.7651 2.2955 2.30007 1.76116 2.9584 1.42804C3.24035 1.28404 3.57933 1.17446 3.93832 1.10202C4.1734 1.0545 4.69079 1.02282 5.09219 1.00886C5.25722 1.00295 5.4712 1 5.56919 1L14.4324 1.00144C14.531 1.00144 14.7447 1.00446 14.9098 1.01037C15.3137 1.02477 15.835 1.05688 16.0726 1.10526C16.4296 1.17806 16.7661 1.288 17.0466 1.43121C17.7045 1.76506 18.2388 2.30004 18.5719 2.9584C18.7159 3.24028 18.8255 3.57926 18.898 3.93818C18.9454 4.17333 18.9772 4.69072 18.9911 5.09212C18.997 5.25736 19 5.4712 19 5.56934L18.9986 14.4322Z",
          fill: "url(#paint0_linear_1264_13435)",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M14.7688 5.25761C13.5502 4.03793 11.9297 3.36595 10.2029 3.36523C6.64516 3.36523 3.74968 6.25963 3.74824 9.81744C3.74683 10.9497 4.044 12.0623 4.60979 13.043L3.69409 16.3867L7.11582 15.4895C8.06225 16.0047 9.12268 16.2747 10.2003 16.2748H10.203C13.7603 16.2748 16.6561 13.3801 16.6575 9.82234C16.6582 8.09823 15.9874 6.477 14.7688 5.25754V5.25761ZM10.203 15.1853H10.2007C9.23999 15.1855 8.29689 14.9273 7.4702 14.4378L7.27429 14.3215L5.24389 14.8543L5.78584 12.8753L5.65847 12.672C5.12092 11.8172 4.83635 10.8276 4.83767 9.8178C4.83911 6.86083 7.24578 4.45517 10.2051 4.45517C11.6379 4.45575 12.985 5.01432 13.9979 6.02808C15.0108 7.04184 15.5683 8.38925 15.5675 9.82248C15.5663 12.7797 13.1597 15.1857 10.2027 15.1857L10.203 15.1853Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8.03878 12.9441C8.08421 12.9715 8.17752 12.9715 8.39158 12.9713C9.29986 12.9705 10.0844 12.9677 10.6424 12.9677C13.2468 12.9677 13.1783 10.2261 11.9606 9.88399C12.139 9.56805 12.9516 8.97449 12.449 7.74761C11.9522 6.53448 9.81487 6.80981 8.3532 6.81053C7.81234 6.81053 7.89327 7.2102 7.896 7.83156C7.90047 8.81573 7.89679 11.4796 7.896 12.6311C7.896 12.8646 7.96649 12.9004 8.03878 12.9441ZM9.16565 11.9394C9.41153 11.9394 9.99156 11.9394 10.4888 11.9386C11.0518 11.9377 11.5532 11.6743 11.5406 11.1138C11.5315 10.5858 11.1802 10.4125 10.6926 10.3642C10.2282 10.3686 9.69708 10.3686 9.16565 10.3686V11.9394ZM9.16565 9.30821C10.1452 9.29474 10.5231 9.34766 11.058 9.21374C11.4252 9.00494 11.586 8.23152 11.06 7.96872C10.6946 7.7862 9.61493 7.84862 9.16565 7.86734V9.30821Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_1264_13435",
                x1: "9.9861",
                y1: "1.03993",
                x2: "9.9861",
                y2: "18.962",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#61FD7D" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#2BB826" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }